import styled from 'styled-components';
  
export const Heading = styled.h1`
   text-align: center;
   color: orange;
`;
  
export const Content = styled.div`
   overflow-Y: scroll;
   height: 2500px;
`;
  
export const Button = styled.div`
   padding-right: 1rem;
   padding-bottom: 4rem;
   position: fixed; 
   width: 80%;
   left: 50%;
   bottom: 40px;
   height: 20px;
   font-size: 3rem;
   z-index: 1;
   cursor: pointer;
   color: grey;
`
